module.exports = __webpack_public_path__ + "media/videos/new_welcome_video-072562a3f9e0ecfaf58fc4e47bc66607.ogg";